var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81471 23.5H2.93724V11.9985H0.5V8.03553H2.93724V5.65627C2.93724 2.42344 4.31271 0.5 8.22302 0.5H11.4776V4.46447H9.44351C7.92126 4.46447 7.82067 5.01827 7.82067 6.05185L7.81396 8.03553H11.5L11.0686 11.9985H7.81396V23.5H7.81471Z",
    fill: "#9EA4A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.fa9b13a9f6095693000cc81564aa3a1b.svg";
export { ForwardRef as ReactComponent };